import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@teals/ui-web";
import type { McpIntegration } from "../../store/api/mcpIntegrationsApi";
import { mcpHost } from "../../store/api/mcpIntegrationsApi";
import { formatRelativeTime } from "../DataSources/relativeTime";
import {
  DSCard,
  CardHeader,
  CardTitle,
  CardRecords,
  AgentChipRow,
  AgentChip,
  CardFooter,
  MetaItem,
  DividerDot,
} from "../DataSources/styles";

interface CustomMcpCardProps {
  mcp: McpIntegration;
  to: string;
  agentNames?: Record<string, string>;
}

const CustomMcpCard: React.FC<CustomMcpCardProps> = ({
  mcp,
  to,
  agentNames = {},
}) => {
  const agentChips = (mcp.agentIds || []).map((id) => ({
    id,
    label: agentNames[id] || id,
  }));
  const authLabel =
    mcp.authMode === "stored_credentials" ? "Stored credentials" : "Caller token";
  const verified = mcp.lastVerifiedAt
    ? formatRelativeTime(mcp.lastVerifiedAt).replace("synced", "verified")
    : "Not verified";

  return (
    <Link to={to} style={{ textDecoration: "none", color: "inherit" }}>
      <DSCard padding={16} elevation="sm" data-testid="custom-mcp-card">
        <CardHeader>
          <CardTitle>{mcp.name}</CardTitle>
          <Badge variant="info" size="sm">
            Custom MCP
          </Badge>
        </CardHeader>
        <CardRecords>
          {mcpHost(mcp.serverUrl) || "No host"}
        </CardRecords>
        {agentChips.length > 0 && (
          <AgentChipRow>
            {agentChips.slice(0, 4).map((chip) => (
              <AgentChip key={chip.id}>{chip.label}</AgentChip>
            ))}
            {agentChips.length > 4 && (
              <AgentChip>+{agentChips.length - 4}</AgentChip>
            )}
          </AgentChipRow>
        )}
        <CardFooter>
          <MetaItem>{authLabel}</MetaItem>
          <DividerDot />
          <MetaItem>{verified}</MetaItem>
        </CardFooter>
      </DSCard>
    </Link>
  );
};

export default CustomMcpCard;
